import React, { useEffect, useState } from "react";
import DropBtn from "../modules/DropBtn";
import Button from "../modules/Button";
import "./register.scss";
import sad from "../../Assets/svg/sad.svg";
import happy from "../../Assets/svg/happy.svg";
import DropSelect from "../modules/AutoComplete";
import { GetBaseUrl } from "../modules/getBaseUrl";
import Status from "../modules/Status";
import { useDispatch, useSelector } from "react-redux";
import { addCandidateInfo, addCandidatePage } from "./redux/actions";
import StaticField from "../StaticField";
import tooltip from "../../Assets/svg/tooltip-icon.png";
import { useNavigate } from 'react-router-dom';

import { mbaColleges, engColleges } from "../modules/CollegeList";
const Degrees = {
  Bachelors: [ "B.Tech", "B.E."],
  MBA: ["MBA", "PGDM", "MMS"],
};

function College() {
  const [universities, setuniversities] = useState([]);
  const navigate = useNavigate()
  const [count, setCount] = useState(25);
  const [type, setType] = useState("regular");
  const dispatch = useDispatch();
  const registeredData = useSelector((state) => state.register.registeredData);

  const nextPage = () => {
    if (type === "regular") {
      if (registeredData?.info?.courseType === "Full Time on Campus") {
        setType("happy");
      } else {
        setType("sad");
      }
    } else if (type === "happy") {
      let url = GetBaseUrl(window.location.href);

      navigate("/signup/income");
    } else {
      let url = GetBaseUrl(window.location.href);
      navigate("/");
      // window.location.replace(url);

    }
  };

      const sadText = () => {
        return (
          <div className="sad-texts">
            <div className="sad-text">
              <img className="tooltip-icon" src={tooltip} alt="tooltip" />
              Only Full Time on Campus courses are eligible for the Program
            </div>
            
          </div>
        );
      };
const dispatchData=(type, e)=>{
  dispatch(addCandidateInfo([type, e]))
}

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const value1 = queryParams.get("paramName");
    console.log(value1);
    let data=[]

    if(registeredData?.info?.course.includes('Engineering')){

      data = engColleges?.map((item) => item["Name of university/College"]);
    }else{
      data = mbaColleges?.map((item) => item["Name of university/College"]);

    }
    // console.log('data', data.length)
    setuniversities([...new Set(data.sort())]);
  }, []);
  useEffect(() => {
    let newCount = 0;
    let list = ["college", "degree", "courseType"];
    if (Object.keys(registeredData)?.length > 0) {
      console.log("registeredData", registeredData);
      for (let i in list) {
        if (registeredData?.info[list[i]] !== "") {
          newCount += 1;
          console.log("count", newCount);
        }
      }
    }
    newCount = Math.abs((newCount / 3) * 100)+25;
    setCount(newCount);
    // console.log("count", newCount);
  }, [registeredData]);
  console.log("registeredData", universities);
  return (
    <div
      className={`cred-section ${
        type !== "sad" && type !== "happy" && "college-section"
      } ${type}`}
    >
      {type === "sad" ? (
        <img className="sad" src={sad} alt="sad" />
      ) : type === "happy" ? (
        <img className="sad" src={happy} alt="happy" />
      ) : (
        ""
      )}
      <span className="title">
        {type === "sad"
          ? registeredData?.info?.courseType !== "" &&
            registeredData?.info?.courseType !== "Full Time on Campus"
            ? "Sorry! You are not eligible"
            : "Sorry! If your college isn’t listed, it’s not covered under the program this year."
          : type === "happy"
          ? "Yes!"
          : "College & Course"}
      </span>
      <span className="sub-title">
        {type === "sad" ?
        registeredData?.info?.courseType !== "" &&
        registeredData?.info?.courseType !== "Full Time on Campus"?
        (
        sadText() 
        ):

        (
          <>
            If you would like to recommend your college for scholarship program,
            kindly email us at <a>{registeredData?.info?.course.includes('Engineering') ? "engscholarship@idfcfirstbank.com":"mbascholarship@idfcfirstbank.com"}</a>
          </>
        ) : type === "happy" ? (
          "Your college and course qualify."
        ) : (
          "Find whether your college and course qualify"
        )}
      </span>
      {type === "regular" && <Status count={count} />}
      {type === "regular" && (
        <div className="cred-fields">
          {/* <CustomDropdown   
          onChange={(e) => dispatch(addCandidateInfo(["college", e]))}
          title={"College/Institute Name"}
          value={registeredData?.info?.college || ""}
          list={universities}
          
          /> */}
          <DropSelect
            onChange={(e) => dispatchData("college", e)}
            title={"College/Institute Name"}
            value={ registeredData?.info?.college || ""}
            list={universities}
          />{" "}
          <DropBtn
            onChange={(e) => dispatchData("degree", e)}
            title={"Degree"}
            pascal={true}
            value={registeredData?.info?.degree}
            list={registeredData?.info?.course.includes('Engineering') ? Degrees.Bachelors: Degrees.MBA}
          />
          <DropBtn
            onChange={(e) => dispatchData("courseType", e)}
            title={"Course Type"}
            value={registeredData?.info?.courseType}
            list={[
              "Full Time on Campus",
              "Part Time",
              // "Distance Learning",
              // "Executive Program",
            ]}
          />
          <StaticField
            showTick={false}
            title={"Batch Year"}
            value={registeredData?.info?.course.includes('Engineering') ?"2024-2028": "2024-2026"}
          />
          {/* <DropSelect
            onChange={(e) =>dispatch(addCandidateInfo(['year',e]))}
            title={"Batch Year"}
            value={value.year}
            list={["2024-2026",'Others']}
          /> */}
        </div>
      )}
      <div className="cred-btn">
        <Button
          disabled={type === "regular" && count < 100}
          onClickHandler={() => nextPage()}
          value={type === "sad" ? "Back to Home" : "Next"}
          type={"contained"}
        />
        {type === "regular" && (
          <Button
            onClickHandler={() => setType("sad")}
            value="My college is not listed here"
            type={"only-text"}
          />
        )}
      </div>
    </div>
  );
}

export default College;
